import {bindable} from 'aurelia-framework';

export class Flutscher {
  @bindable slideIn;
  @bindable backgroundSplit: string = 'normal';
  roundedImage: Element;
  widthString: string = '';

  attached(){
    const width = this.roundedImage.clientHeight;
    this.widthString = `width: ${width}px `;
    window.addEventListener('resize', ()=> {
      const width = this.roundedImage.clientHeight;
      this.widthString = `width: ${width}px `;
    })
  }


  valueChanged(newValue, oldValue) {
    //
  }
}
